/* [LB-2026-10-17 NEW FILE] Size-picker hint ("option A": hopping yellow box).
   While no size is selected: a yellow box hops from size to size (left to right, then back, repeating) and the size row
   scrolls to follow it. Stops for good the moment the shopper touches / scrolls / clicks the row or a size is selected.
   Pauses while the row is off-screen and resumes when visible. Skipped for prefers-reduced-motion.
   Works for lists injected later (quick shop popup) via MutationObserver. Loaded with defer from layout/theme.liquid.
   Box look + colour: assets/custom-ss-lb.css (.lb-hl, variable --lb-hl). Speed: HOP below. Search LB-2026-10-17. */
(function () {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var SEL = '.t4s-swatch__option:not(.is-t4s-style__color) .t4s-swatch__list';
  var ITEMS = '.t4s-swatch__item:not([class*="sold"]):not([class*="disabled"])';
  var DELAY = 700; /* ms before the first hop (lets the chips finish sliding in) */
  var HOP = 620;   /* ms the box rests on each size before hopping to the next. Lower = faster */

  function halt(el) { /* pause (not permanent) */
    var S = el._lb;
    clearTimeout(S.timer); S.timer = 0;
    if (S.box) S.box.classList.remove('on');
    if (S.on) { el.style.scrollSnapType = S.s; S.on = 0; }
  }
  function kill(el) { /* permanent */
    var S = el._lb; S.stop = 1; halt(el);
    var bx = S.box; S.box = null;
    if (bx) setTimeout(function () { if (bx.parentNode) bx.parentNode.removeChild(bx); }, 300);
  }
  function hop(el) {
    var S = el._lb;
    if (S.stop || !S.vis || !el.isConnected) return halt(el);
    if (el.querySelector('.is--selected')) return kill(el);
    var items = el.querySelectorAll(ITEMS);
    if (!items.length) return halt(el);
    if (S.i >= items.length) { S.i = items.length - 2; S.dir = -1; }
    if (S.i < 0) { S.i = Math.min(1, items.length - 1); S.dir = 1; }
    var c = items[S.i], bx = S.box;
    bx.style.width = (c.offsetWidth + 4) + 'px';
    bx.style.height = (c.offsetHeight + 4) + 'px';
    bx.style.transform = 'translate(' + (c.offsetLeft - 2) + 'px,' + (c.offsetTop - 2) + 'px)';
    bx.classList.add('on');
    var max = el.scrollWidth - el.clientWidth;
    if (max > 8) { /* keep the box in view: centre the current size */
      var want = c.offsetLeft + c.offsetWidth / 2 - el.clientWidth / 2;
      el.scrollTo({ left: Math.max(0, Math.min(want, max)), behavior: 'smooth' });
    }
    S.i += S.dir;
    S.timer = setTimeout(function () { hop(el); }, HOP);
  }
  function start(el) {
    var S = el._lb;
    if (S.stop || S.timer || !S.vis || !el.isConnected) return;
    if (el.querySelector('.is--selected')) return kill(el);
    if (!el.querySelector(ITEMS)) return;
    if (!S.box) {
      S.box = document.createElement('i'); S.box.className = 'lb-hl'; S.box.setAttribute('aria-hidden', 'true');
      el.appendChild(S.box); S.i = 0; S.dir = 1;
      S.box.style.transition = 'none';                 /* first placement: no glide from the corner */
      var c = el.querySelector(ITEMS);
      S.box.style.width = (c.offsetWidth + 4) + 'px'; S.box.style.height = (c.offsetHeight + 4) + 'px';
      S.box.style.transform = 'translate(' + (c.offsetLeft - 2) + 'px,' + (c.offsetTop - 2) + 'px)';
      void S.box.offsetWidth; S.box.style.transition = '';
    }
    S.s = el.style.scrollSnapType; el.style.scrollSnapType = 'none'; S.on = 1;
    hop(el);
  }

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var el = e.target, S = el._lb;
      if (!el.isConnected) { io.unobserve(el); return; }
      S.vis = e.isIntersecting;
      if (S.vis) setTimeout(function () { start(el); }, DELAY); else halt(el);
    });
  }, { threshold: .6 });

  function watch(el) {
    if (el._lb) return;
    el._lb = { vis: 0, stop: 0, timer: 0, on: 0, box: null, i: 0, dir: 1 };
    ['touchstart', 'wheel', 'pointerdown'].forEach(function (ev) {
      el.addEventListener(ev, function () { kill(el); }, { passive: true });
    });
    io.observe(el);
  }
  function scan(root) {
    if (root.matches && root.matches(SEL)) watch(root);
    if (root.querySelectorAll) Array.prototype.forEach.call(root.querySelectorAll(SEL), watch);
  }
  scan(document);
  new MutationObserver(function (ms) {
    ms.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1 && !(n.classList && n.classList.contains('lb-hl'))) scan(n); }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
